import React, { StrictMode, useEffect, useMemo } from "react";
import * as ReactDOM from "react-dom/client";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

import App from "./App";
import theme from "./Theme/theme.js";
import "./i18n";
import "./index.css";

function Root() {
  const { i18n } = useTranslation();

  const isArabic = (i18n.language || "en").toLowerCase().startsWith("ar");

  // Update document direction + lang attribute
  useEffect(() => {
    document.documentElement.lang = isArabic ? "ar" : "en";
    document.documentElement.dir = isArabic ? "rtl" : "ltr";
  }, [isArabic]);

  // Create a theme that switches font based on language
  const dynamicTheme = useMemo(() => {
    const chosenFont = isArabic ? theme.fonts.arabic : theme.fonts.english;

    return {
      ...theme,
      styles: {
        global: {
          body: {
            bg: "white",
            color: "gray.800",
            fontFamily: chosenFont,
          },
        },
      },
    };
  }, [isArabic]);

  return (
    <ChakraProvider theme={dynamicTheme}>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <App />
    </ChakraProvider>
  );
}

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <StrictMode>
    <Root />
  </StrictMode>
);
